import { IoClose } from "react-icons/io5";
import React from "react";

export default function ChatWindow({
  children,
  title,
  customClass,
  onClose,
  onAnimationEnd,
}) {
  return (
    <div
      className={`fixed flex bottom-0 flex-col left-0 w-full h-3/5 z-50 bg-altgray-50  ${customClass}`}
      onAnimationEnd={onAnimationEnd}
    >
      {onClose && (
        <button
          onClick={onClose}
          className="absolute right-5 top-5 btn btn-icon btn-icon-md btn-goast"
        >
          <div className="text-2xl">
            <IoClose />
          </div>
        </button>
      )}
      <div className="text-xl bg-white md:text-2xl p-6 border-b border-b-altgray-200 font-semibold">
        {title}
      </div>
      {children}
    </div>
  );
}
